import React, { useEffect, useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import styles from './SceneTimer.module.css';

const SceneTimer = ({ duration = 6000, onExpire, paused = false }) => {
  const [remaining, setRemaining] = useState(duration);

  useEffect(() => {
    setRemaining(duration);
  }, [duration]);

  useEffect(() => {
    if (paused) return undefined;
    const startedAt = Date.now();
    const timer = window.setInterval(() => {
      const elapsed = Date.now() - startedAt;
      const next = Math.max(duration - elapsed, 0);
      setRemaining(next);
      if (next <= 0) {
        window.clearInterval(timer);
        if (onExpire) onExpire();
      }
    }, 100);
    return () => window.clearInterval(timer);
  }, [duration, onExpire, paused]);

  const ratio = useMemo(() => Math.max(remaining / duration, 0), [remaining, duration]);
  const color = ratio > 0.66 ? '#e9c46a' : ratio > 0.33 ? '#f4a261' : '#e63946';

  return (
    <div className={styles.track}>
      <motion.div
        className={styles.fill}
        style={{ background: color, transformOrigin: 'left center' }}
        animate={{ scaleX: ratio }}
        transition={{ type: 'tween', duration: 0.1, ease: 'linear' }}
      />
    </div>
  );
};

export default SceneTimer;
